import React, { useEffect, useState, useRef } from 'react';
type Particle = {
  id: number;
  x: number;
  y: number;
  tx: number;
  ty: number;
  color: string;
  size: number;
};
const COLORS = ['#A855F7', '#3B82F6', '#22D3EE', '#EC4899', '#F5F5F5' // soft white
];
let pid = 0;
export function MouseExplosion() {
  const [enabled, setEnabled] = useState(false);
  const [particles, setParticles] = useState<Particle[]>([]);
  const lastEmit = useRef(0);
  const lastPos = useRef({
    x: 0,
    y: 0
  });
  // Only enable on devices with a fine pointer (i.e. mouse, not touch).
  // This is a major performance win on mobile.
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia('(hover: hover) and (pointer: fine)');
    const update = () => setEnabled(mql.matches);
    update();
    mql.addEventListener?.('change', update);
    return () => mql.removeEventListener?.('change', update);
  }, []);
  useEffect(() => {
    if (!enabled) return;
    function onMove(e: MouseEvent) {
      const now = performance.now();
      if (now - lastEmit.current < 40) return;
      lastEmit.current = now;
      const dx = e.clientX - lastPos.current.x;
      const dy = e.clientY - lastPos.current.y;
      const speed = Math.min(Math.hypot(dx, dy), 60);
      lastPos.current = {
        x: e.clientX,
        y: e.clientY
      };
      const count = speed > 8 ? 2 : 1;
      const next: Particle[] = [];
      for (let i = 0; i < count; i++) {
        const angle = Math.random() * Math.PI * 2;
        const distance = 40 + Math.random() * 80;
        next.push({
          id: ++pid,
          x: e.clientX,
          y: e.clientY,
          tx: Math.cos(angle) * distance,
          ty: Math.sin(angle) * distance,
          color: COLORS[Math.floor(Math.random() * COLORS.length)],
          size: 4 + Math.random() * 6
        });
      }
      setParticles(prev => [...prev.slice(-30), ...next]);
      setTimeout(() => {
        setParticles(prev => prev.filter(p => !next.find(n => n.id === p.id)));
      }, 850);
    }
    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, [enabled]);
  if (!enabled) return null;
  return <div className="fixed inset-0 pointer-events-none z-[60] overflow-hidden" data-id="element-288">
      {particles.map(p => <div key={p.id} className="absolute particle-explosion rounded-full" style={{
      left: p.x,
      top: p.y,
      width: p.size,
      height: p.size,
      background: p.color,
      boxShadow: `0 0 ${p.size * 3}px ${p.color}, 0 0 ${p.size * 6}px ${p.color}80`,
      ['--tx' as any]: `${p.tx}px`,
      ['--ty' as any]: `${p.ty}px`
    }} data-id="element-289" />)}
    </div>;
}